"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "hash": "ac056b7",
    "raw": "v2.25.0",
    "semverString": "2.25.0"
};
//# sourceMappingURL=version.js.map